import { ICustomerInformationData } from '../customer-information/CustomerInformation'
import { AvailabilityCalendarSlot } from '../../../../../../../app/types/scheduling'
import { IOrderService } from '../../../../../../../app/entities/OrderService'
import { ITiresCombination } from '../../../../../../../app/entities/TiresCombination'
import { ITire } from '../../../../../../../app/entities/Tire'
import { DeepPartial } from 'typeorm'

export interface ISchedulerStateProps {
  customerInformation: ICustomerInformationData
  tiresCombination: DeepPartial<ITiresCombination>
  orderId: string
  orderVehicleId: string
  customerId: string
  customerVehicleId: string
  tireDisposal: boolean
  freeOrderReason: {
    objectId: string
    reason: string
    isFree: boolean
  }
  status: string
  service: string //this is actually the serviceObjectId -__-
  orderService: string //this is actually the orderServiceObjectId -__-
  disposalQty: number
  shouldRequestPaymentAfterScheduling: boolean
  selectedAvailabilityCalendarSlot?: AvailabilityCalendarSlot
  availableCalenderFromDateOverride?: number
  genericItems?: IOrderService[]
  stateTireFee?: IOrderService
  servicePriceOverride?: number
  daysFromEarliestAvailableDate?: number
}

const initialCustomerInfoProps: ICustomerInformationData = {
  firstName: '',
  lastName: '',
  phone: '',
  email: '',
  address: '',
  aptOrSuite: '',
  city: '',
  state: '',
  zipCode: '',
  additionalInformation: '',
  brandName: '',
  model: '',
  year: '',
  variant: '',
  brandId: '',
  mileage: null,
  installationPointObjectId: '',
}

const intialTireProps: DeepPartial<ITire> = {
  aspectRatio: null,
  width: '',
  diameter: 0,
  psi: 0,
  manufacturer: '',
  model: '',
  torque: 0,
}

const initialTiresCobinationProps: DeepPartial<ITiresCombination> = {
  frontCount: 2,
  rearCount: 2,
  frontTire: intialTireProps,
  rearTire: intialTireProps,
}

const initialStateProps: ISchedulerStateProps = {
  customerInformation: initialCustomerInfoProps,
  tiresCombination: initialTiresCobinationProps,
  orderId: '',
  orderVehicleId: '',
  customerId: '',
  customerVehicleId: '',
  tireDisposal: true,
  disposalQty: 4,
  status: '',
  freeOrderReason: {
    objectId: '',
    reason: '',
    isFree: false,
  },
  service: '4068CCA8-EE44-4754-8764-61B9427DC68E', //this is the Tire Install Service ObjectId -__-
  orderService: '',
  availableCalenderFromDateOverride: undefined,
  shouldRequestPaymentAfterScheduling: false,
  genericItems: [],
}

/**
 * Helper function to get a deep clone of initialStateProps
 * Use this instead of spreading initialStateProps to prevent accidental mutations
 */
export function getInitialStateProps(): ISchedulerStateProps {
  return {
    ...initialStateProps,
    customerInformation: { ...initialStateProps.customerInformation },
    tiresCombination: {
      ...initialStateProps.tiresCombination,
      frontTire: { ...initialStateProps.tiresCombination.frontTire },
      rearTire: { ...initialStateProps.tiresCombination.rearTire },
    },
    freeOrderReason: { ...initialStateProps.freeOrderReason },
    genericItems: [...(initialStateProps.genericItems || [])],
  }
}
